export const PASSWORD_MAX_LENGTH = 72;

export async function validatePassword(value: string): Promise<string> {
    if (value.length === 0) {
        // Empty
        return 'shared.fields.password.error_required';
    }

    if (value.length > PASSWORD_MAX_LENGTH) {
        // Too long
        return 'shared.fields.password.error_too_long';
    }

    // We ignore the password rules above 15 characters
    if (value.length >= 15) {
        return '';
    }

    const noLowercase = !/[a-z]/.test(value);
    const noNumber = !/[0-9]/.test(value);

    if (value.length < 8) {
        // Too short
        if (noLowercase && noNumber) {
            return 'shared.fields.password.error_too_short_no_lowercase_no_number';
        }
        if (noLowercase) {
            return 'shared.fields.password.error_too_short_no_lowercase';
        }
        if (noNumber) {
            return 'shared.fields.password.error_too_short_no_number';
        }
        return 'shared.fields.password.error_too_short';
    }

    if (noLowercase && noNumber) {
        return 'shared.fields.password.error_no_lowercase_no_number';
    }
    if (noLowercase) {
        return 'shared.fields.password.error_no_lowercase';
    }
    if (noNumber) {
        return 'shared.fields.password.error_no_number';
    }

    // Lazy load the CommonPasswordList only when needed
    const { default: CommonPasswordList } = await import(
        'fxa-common-password-list'
    );
    if (CommonPasswordList.test(value)) {
        return 'shared.fields.password.error_common';
    }

    return '';
}
